import styled from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';

const DESKTOP_POP_UP_WIDTH = '315px';

export default styled.div<{ isFullWidth: boolean }>`
    position: relative;
    bottom: auto;
    max-height: 100vh;
    overflow: auto;
    top: 0;
    display: block;
    left: 0;
    width: 100%;
    text-align: center;
    transition: 0.2s ease-in-out;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE 10+ */
    scrollbar-width: none; /* Firefox */
    z-index: ${({ theme }) => theme.zIndexPopUpOverlay};
    ${({ isFullWidth }) => (isFullWidth ? '' : 'margin: 0 8%;')}

    &::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
    }
    ${forDesktop`
        width: ${DESKTOP_POP_UP_WIDTH};
        margin: 0 auto;
    `}
`;
